import React from "react";
import { Link } from "react-router-dom";

const FooterOne = () => {
  return (
    <footer>
      <div className="footer-area">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-sm-6">
                <div className="footer-widget">
                  <div className="logo">
                    <Link to="/">
                      <img src="/img/logo/w_logo.png" alt="Vernu Stoffering logo" />
                    </Link>
                  </div>
                  <div className="footer-contact">
  <span>Meer weten over onze diensten?</span>
  <div className="footer-slogan-rotator">
    <span className="slogan-title">✨ Vernu betekent:</span>
    <div className="slogan-viewport">
      <ul className="slogan-list">
        <li>Vakkundige stoffering</li>
        <li>Maatwerk tot in detail</li>
        <li>Duurzame materialen</li>
        <li>Herstoffering met liefde</li>
        <li>Comfort met karakter</li>
      </ul>
    </div>
  </div>

  <div className="footer-social-links">
  <a
    href="https://www.instagram.com/diana.meubelstofferen"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Instagram"
  >
    <i className="fab fa-instagram"></i>
  </a>

  <a
    href="https://www.tiktok.com/@diana.meubelstofferen"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="TikTok"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 48 48"
      fill="currentColor"
    >
      <path d="M41.6 15.9c-4 0-7.3-2.8-8.1-6.5l-0.3-1.4h-5.8v23.9c0 2.4-1.9 4.3-4.3 4.3s-4.3-1.9-4.3-4.3c0-2.4 1.9-4.3 4.3-4.3 0.7 0 1.3 0.2 1.9 0.5v-6.3c-0.6-0.1-1.2-0.1-1.9-0.1-5.9 0-10.6 4.8-10.6 10.6 0 5.9 4.8 10.6 10.6 10.6 5.9 0 10.6-4.8 10.6-10.6v-12.2c2.3 1.5 5.1 2.3 8.1 2.3v-6.3z" />
    </svg>
  </a>

  <a
    href="https://wa.me/31614507471"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="WhatsApp"
  >
    <i className="fab fa-whatsapp"></i>
  </a>
</div>


</div>

                </div>
              </div>

              <div className="col-lg-3 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">Navigatie</h4>
                  <div className="fw-link">
                    <ul className="list-wrap">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/about-us">Over ons</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">Openingstijden</h4>
                  <div className="fw-link">
                  <ul className="footer-opening-hours">
                    <li>
                      <strong>Ma - Vr:</strong> 09:00 - 18:00
                    </li>
                    <li>
                      <strong>Za:</strong> 10:00 - 17:00
                    </li>
                    <li>
                      <strong>Zo:</strong> Gesloten
                    </li>
                  </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">Contactgegevens</h4>
                  <div className="footer-about">
                    <ul className="list-wrap">
                      <li>
                        <img src="/img/icon/phone_icon.svg" alt="" />
                        <a href="tel:0614507471">06-14507471</a>
                      </li>
                      <li>
                        <img src="/img/icon/mail_icon.svg" alt="" />
                        <a href="mailto:info@dianakledingreparatie.nl">info@dianakledingreparatie.nl</a>
                      </li>
                      <li>
                        <img src="/img/icon/loction_icon.svg" alt="" />
                        <span>Abtsweg 41A - 43A, 3042 GA Rotterdam</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-6">
                <div className="powered-by-text text-start">
                  <p>
                    Website ontworpen & gebouwd door{" "}
                    <a
                      href="https://nebicanlioglu.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Nebi Canlioglu
                    </a>
                    .
                  </p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="copyright-text text-end">
                  <p>© {new Date().getFullYear()} Vernu Stoffering. Alle rechten voorbehouden.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterOne;
